import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import getEnv from '../getEnv'

const Version = () => {
  const location = useLocation()

  useEffect(() => {
    const checkVersion = async () => {
      if (getEnv() === 'local') return
      let path
      switch (getEnv()) {
        case 'dev':
          path = 'https://develop.orionx.com/waves-current-version.json'
          break
        case 'beta':
          path = 'https://beta.orionx.com/waves-current-version.json'
          break
        case 'castor':
          return
        default:
          path = 'https://app.orionx.com/waves-current-version.json'
          break
      }
      const response = await fetch(path, {
        method: 'GET',
        mode: 'no-cors',
      })

      console.log('response: ', response)
      const { version } = await response.json()
      console.log('[Current Client Version]: ', version)
      saveVersion(version)
    }

    const saveVersion = newVersion => {
      if (!newVersion) return
      localStorage.setItem('clientVersion', newVersion)
      const oldVersion = localStorage.getItem('clientVersion')
      if (!oldVersion) {
        console.log('no old version saved')
      } else if (oldVersion !== newVersion) {
        console.log(`upgrading from version ${oldVersion} to ${newVersion}`)
        window.location.reload(true)
      }
    }

    checkVersion()

    const interval = setInterval(checkVersion, 30000)

    return () => {
      clearInterval(interval)
    }
  }, [location])

  return <span />
}

export default Version
